import { render, staticRenderFns } from "./AirportVip.vue?vue&type=template&id=9479d53a&scoped=true&"
import script from "./AirportVip.vue?vue&type=script&lang=js&"
export * from "./AirportVip.vue?vue&type=script&lang=js&"
import style0 from "./AirportVip.vue?vue&type=style&index=0&id=9479d53a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9479d53a",
  null
  
)

export default component.exports